import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import PageShell from "@/components/PageShell";
import Button from "@/components/Button";
import FormField from "@/components/FormField";
import { api, setAuthToken } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onLogin = async (ev) => {
    ev?.preventDefault?.();
    if (!email.trim() || !password.trim()) {
      toast.error("Please enter email and password.");
      return;
    }
    setLoading(true);
    try {
      const res = await api.adminLogin(email.trim().toLowerCase(), password);
      setAuthToken(res.access_token, res.admin_email);
      toast.success("Welcome back!");
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      toast.error(err.message || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageShell testid="admin-login-screen">
      <div className="max-w-md mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-14 h-14 rounded-full bg-sprouts-lavender flex items-center justify-center">
            <Lock size={28} className="text-sprouts-primary" />
          </div>
          <div>
            <h1 className="text-2xl sm:text-3xl font-black text-sprouts-text">Admin Sign-in</h1>
            <p className="text-sm text-sprouts-muted mt-1">For Sprouts team only.</p>
          </div>
        </div>

        <form
          onSubmit={onLogin}
          className="bg-white rounded-2xl p-6 border border-sprouts-border shadow-card"
        >
          <FormField
            label="Email"
            type="email"
            autoCapitalize="none"
            placeholder="admin@sproutsedutours.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="admin-email"
          />
          <FormField
            label="Password"
            type="password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="admin-password"
          />
          <div className="mt-3">
            <Button type="submit" loading={loading} data-testid="admin-login-btn" fullWidth>
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </div>
        </form>
      </div>
    </PageShell>
  );
}
